import React, { useState, useEffect } from "react";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { useNavigate } from "react-router-dom";
import {
  errorToaster,
  successToaster,
} from "../../../helper/toasterConfiguration";
import { Styles } from "./styles";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import LogoSelect from "./logo-select";
import Files from "react-files";
import CloseIcon from "@mui/icons-material/Close";
import PaymentDoc from "./payment-doc";

const AddOrderForm = ({
                        services,
                        isServicesLoading,
                        panels,
                        isPanelsLoading,
                        users,
                        isUsersLoading,
                      }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [uploadOption, setUploadOption] = useState("logo");
  const [selectedFont, setSelectedFont] = useState("Mockads");
  const [selectedColor, setSelectedColor] = useState("#EBF2FF");
  const [logoName, setLogoName] = useState("LOREM");
  const [payment_note, setPayment_note] = useState("LOREM");
  const [fontSize, setFontSize] = useState(25);
  const [selectedService, setSelectedService] = useState();
  const [selectedType, setSelectedType] = useState(null);
  const [price, setPrice] = useState();
  const [discount, setDiscount] = useState();
  const [count, setCount] = useState();
  const itemsPerPage = 25;

  // Add state for selected user and filtered panels
  const [selectedUser, setSelectedUser] = useState(null);
  const [userFilteredPanels, setUserFilteredPanels] = useState([]);

  // Panels State
  const [panelsPage, setPanelsPage] = useState(1);
  const [panelSearchQuery, setPanelSearchQuery] = useState("");

  // Filter panels based on selected user's ID
  useEffect(() => {
    if (selectedUser && panels.length > 0) {
      // Filter panels that have user_id equal to the selected user's ID
      const filtered = panels.filter(panel => panel.user_id === selectedUser.id);
      setUserFilteredPanels(filtered);

      // Reset panel selection when user changes
      setData(prev => ({ ...prev, panel_id: "" }));
    } else {
      // If no user is selected, show all panels
      setUserFilteredPanels(panels);

      // Reset panel selection when user is cleared
      setData(prev => ({ ...prev, panel_id: "" }));
    }
  }, [selectedUser, panels]);

  // Use userFilteredPanels for display
  const paginatedPanels = userFilteredPanels.slice(0, panelsPage * itemsPerPage);
  const filteredPanels = userFilteredPanels.filter((panel) =>
      panel.name.toLowerCase().includes(panelSearchQuery.toLowerCase())
  );
  const displayedPanels = panelSearchQuery ? filteredPanels : paginatedPanels;

  // Users State
  const [usersPage, setUsersPage] = useState(1);
  const [userSearchQuery, setUserSearchQuery] = useState("");
  const paginatedUsers = users.slice(0, usersPage * itemsPerPage);
  const filteredUsers = users.filter((user) =>
      user.name.toLowerCase().includes(userSearchQuery.toLowerCase())
  );
  const displayedUsers = userSearchQuery ? filteredUsers : paginatedUsers;

  // Offers State
  const [servicesPage, setServicesPage] = useState(1);
  const [servicesSearchQuery, setServicesSearchQuery] = useState("");
  const paginatedServices = services.slice(0, servicesPage * itemsPerPage);
  const filteredServices = services.filter((service) =>
      service.name.toLowerCase().includes(servicesSearchQuery.toLowerCase())
  );
  const displayedServices = servicesSearchQuery
      ? filteredServices
      : paginatedServices;

  const [data, setData] = useState({
    our_service_id: "",
    our_service_type_id: "",
    panel_id: "",
    title: "",
    price: "",
    description: "",
    payment_method: "",
    user_id: "",
    logo: "",
    customLogo: "",
    payment_document: "",
    payment_note: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
    setPrice(null);
  };

  const handlePanelChange = (event, value) => {
    setData((prev) => ({ ...prev, panel_id: value?.id || "" }));
  };

  const handleUserChange = (event, value) => {
    setSelectedUser(value);
    setData((prev) => ({
      ...prev,
      user_id: value?.id || "",
      panel_id: "" // Reset panel selection when user changes
    }));
  };

  const handleServiceChange = (event, value) => {
    if (!value) {
      setData((prev) => ({ ...prev, our_service_type_id: "" }));
    }
    setSelectedType(null);
    setData((prev) => ({ ...prev, our_service_id: value?.id || "" }));
    setSelectedService(value);
  };

  const handleTypeChange = (event, value) => {
    setSelectedType(value);
    setData((prev) => ({ ...prev, our_service_type_id: value?.id || "" }));
    setData((prev) => ({
      ...prev,
      price:
          selectedService?.type?.find((service) => service?.id === value?.id)
              ?.price || "",
    }));
    setPrice(
        selectedService?.type?.find((service) => service?.id === value?.id)?.price
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const   requiredFields = [
        "our_service_id",
          "count",
        "panel_id",
      ];


    const updatedFormData = {
      ...data,
    };

    const missingFields = requiredFields.filter(
        (field) => !updatedFormData[field]
    );

    if (selectedService?.FiledImage) {
      if (uploadOption === "logo") {
        if (!data.logo) {
          missingFields.push("logo");
        }
      } else if (uploadOption === "customLogo") {
        // Validate individual properties for custom logo
        if (!logoName || !selectedColor || !selectedFont || !fontSize) {
          missingFields.push(
              "customLogo properties (logoName, color, fontFamily, fontSize)"
          );
        }
      }
    }

    if (missingFields.length > 0) {
      errorToaster(
          `Please fill in all required fields: ${missingFields.join(", ")}`
      );
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    const form_data = new FormData();
    form_data.append("payment_document", data.payment_document);
    // Append form data based on the active upload option
    if (selectedService?.FiledImage) {
      if (uploadOption === "logo" && data.logo) {
        form_data.append("logo", data.logo);
      } else if (uploadOption === "customLogo") {
        updatedFormData.customLogo = {
          fontSize: `${fontSize}px`,
          color: selectedColor,
          fontFamily: selectedFont,
          logoName: logoName,
        };
        Object.keys(updatedFormData.customLogo).forEach((key) => {
          form_data.append(
              `customLogo[${key}]`,
              updatedFormData.customLogo[key]
          );
        });
      }
    }
    updatedFormData.payment_note = payment_note;
    // Append other form data fields
    Object.keys(updatedFormData).forEach((key) => {
      const value = updatedFormData[key];
      if (value && key !== "logo" && key !== "customLogo" && key !== "payment_document") {
        form_data.append(key, value);
      }
    });

    const result = await Helper.Post({
      url: api_Routes.Orders.Add,
      data: form_data,
      hasToken: true,
    });

    const { response, message } = result || {};

    if (response) {
      successToaster(message);
      navigate("/Orders");
    }
    setIsLoading(false);
  };

  const handlePaymentDocumentChange = (files) => {
    if (files && files.length > 0) {
      setData((prev) => ({ ...prev, payment_document: files[0] }));
    }
  };

  return (
      <Styles>
        <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-y-6">
          <div className="flex flex-col justify-between items-center gap-6 md:flex-row w-full">
            {/* Panels Autocomplete */}
            <div className="w-full">
              <Autocomplete
                  disablePortal
                  loading={isPanelsLoading}
                  options={displayedPanels}
                  getOptionLabel={(option) => option.name || ""}
                  onChange={handlePanelChange}
                  onInputChange={(event, value) => setPanelSearchQuery(value)}
                  value={displayedPanels.find(panel => panel.id === data.panel_id) || null}
                  disabled={!data.user_id}
                  renderInput={(params) => (
                      <TextField
                          {...params}
                          label="Panel"
                          variant="outlined"
                          helperText={!data.user_id ? "Please select a user first" : ""}
                      />
                  )}
                  ListboxProps={{
                    onScroll: (event) => {
                      const listboxNode = event.currentTarget;
                      if (
                          listboxNode.scrollTop + listboxNode.clientHeight >=
                          listboxNode.scrollHeight - 3
                      ) {
                        setPanelsPage((prevPage) => prevPage + 1);
                      }
                    },
                  }}
              />
            </div>

            {/* Users Autocomplete */}
            <div className="w-full">
              <Autocomplete
                  disablePortal
                  loading={isUsersLoading}
                  options={displayedUsers}
                  getOptionLabel={(option) => option.name || ""}
                  onChange={handleUserChange}
                  onInputChange={(event, value) => setUserSearchQuery(value)}
                  renderInput={(params) => (
                      <TextField {...params} label="User" variant="outlined" />
                  )}
                  ListboxProps={{
                    onScroll: (event) => {
                      const listboxNode = event.currentTarget;
                      if (
                          listboxNode.scrollTop + listboxNode.clientHeight >=
                          listboxNode.scrollHeight - 3
                      ) {
                        setUsersPage((prevPage) => prevPage + 1);
                      }
                    },
                  }}
              />
            </div>
          </div>
          <div className="flex flex-col justify-between items-center gap-6 md:flex-row">
            <div className="w-full">
              <Autocomplete
                  disablePortal
                  loading={isServicesLoading}
                  options={displayedServices}
                  getOptionLabel={(option) => option.name || ""}
                  onChange={handleServiceChange}
                  onInputChange={(event, value) => setServicesSearchQuery(value)}
                  renderInput={(params) => (
                      <TextField {...params} label="Service" variant="outlined" />
                  )}
                  ListboxProps={{
                    onScroll: (event) => {
                      const listboxNode = event.currentTarget;
                      if (
                          listboxNode.scrollTop + listboxNode.clientHeight >=
                          listboxNode.scrollHeight - 3
                      ) {
                        setServicesPage((prevPage) => prevPage + 1);
                      }
                    },
                  }}
              />
            </div>
            <div className="w-full">
              <div className="flex flex-col justify-between items-center gap-x-6 md:flex-row">
                {(selectedService && selectedService.is_days) && (
                    <TextField
                        fullWidth
                        label="Days"
                        name="count"
                        type={'number'}
                        required
                        autoComplete="off"
                        value={data?.count || count || ""}
                        onChange={handleInputChange}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: Boolean(data?.count || count),
                        }}
                    />
                )}
                {(selectedService && selectedService.is_tickets) && (
                    <TextField
                        fullWidth
                        label="Tickets Count"
                        name="count"
                        type={'number'}
                        required
                        autoComplete="off"
                        value={data?.count || count || ""}
                        onChange={handleInputChange}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: Boolean(data?.count || count),
                        }}
                    />
                )}
              </div>
            </div>
          </div>

          {(selectedService?.FiledTitle ||
              selectedService?.FiledDescription ||
              selectedService?.name === "Pin Up" ||
              selectedService?.name === "Pin Down") && (
              <div className="flex flex-col justify-between items-center gap-x-6 md:flex-row">
                {selectedService?.FiledTitle && (
                    <TextField
                        fullWidth
                        label="Title"
                        name="title"
                        required
                        autoComplete="off"
                        value={data?.title}
                        onChange={handleInputChange}
                        variant="outlined"
                    />
                )}
                {selectedService?.FiledDescription && (
                    <TextField
                        fullWidth
                        multiline
                        minRows={1}
                        variant="outlined"
                        InputLabelProps={{
                          style: { color: "#434343", fontSize: "13px" },
                        }}
                        sx={{
                          background: "white",
                          borderRadius: "8px",
                          "& .MuiOutlinedInput-root": {
                            border: "1px solid #5F5F5F",
                            boxShadow: "-2px 2px 4px #00000040",
                            borderRadius: "8px",
                            "& fieldset": {
                              border: "none",
                            },
                            "& textarea": {
                              borderRadius: "10px",
                            },
                          },
                        }}
                        label="Description"
                        name="description"
                        required
                        autoComplete="off"
                        value={data?.description}
                        onChange={handleInputChange}
                    />
                )}
                {(selectedService?.name === "Pin Up" ||
                    selectedService?.name === "Pin Down") && (
                    <TextField
                        fullWidth
                        label="Priority"
                        name="priority"
                        required
                        autoComplete="off"
                        value={data?.priority}
                        onChange={handleInputChange}
                        variant="outlined"
                    />
                )}
              </div>
          )}
          <div className="flex flex-col justify-between items-center gap-x-6 md:flex-row">
            {selectedService && (
                <>
                  <TextField
                      fullWidth
                      label="Price"
                      name="price"
                      type={'number'}
                      required
                      autoComplete="off"
                      value={data?.price || price || ""}
                      onChange={handleInputChange}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: Boolean(data?.price || price),
                      }}
                  />
                  <TextField
                      fullWidth
                      label="Discount"
                      name="discount"
                      type={'number'}
                      required
                      autoComplete="off"
                      value={data?.discount || discount || ""}
                      onChange={handleInputChange}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: Boolean(data?.discount || discount),
                      }}
                  />
                </>
            )}
            <FormControl className="w-full">
              <InputLabel id="discount-type-select-label">
                Discount Type
              </InputLabel>
              <Select
                  labelId="discount-type-select-label"
                  id="discount-type-select"
                  value={data.discount_type || null}
                  onChange={(e) => {
                    setData((prev) => ({
                      ...prev,
                      ["discount_type"]: e.target.value,
                    }));
                  }}
                  label="Discount Type"
                  sx={{ textAlign: "start" }}
              >
                <MenuItem value="none">None</MenuItem>
                <MenuItem value="const">Constant</MenuItem>
                <MenuItem value="percentage">Percentage</MenuItem>
              </Select>
            </FormControl>
          </div>

          {selectedService?.FiledImage && (
              <LogoSelect
                  data={data}
                  setData={setData}
                  uploadOption={uploadOption}
                  setUploadOption={setUploadOption}
                  logoName={logoName}
                  setLogoName={setLogoName}
                  selectedFont={selectedFont}
                  setSelectedFont={setSelectedFont}
                  selectedColor={selectedColor}
                  setSelectedColor={setSelectedColor}
                  fontSize={fontSize}
                  setFontSize={setFontSize}
              />
          )}

          <div className="submit-btn">
            <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={isLoading}
            >
              {isLoading ? (
                  <CircularProgress size={22} sx={{ color: "white" }} />
              ) : (
                  "Submit"
              )}
            </Button>
          </div>
        </form>
      </Styles>
  );
};

export default AddOrderForm;